export default {
  getMyFlyers: state => state.myFlyers
};
